import { render } from "./TicketUser.vue?vue&type=template&id=ccbbcd12&scoped=true"
import script from "./TicketUser.vue?vue&type=script&lang=js"
export * from "./TicketUser.vue?vue&type=script&lang=js"

import "./TicketUser.vue?vue&type=style&index=0&id=ccbbcd12&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccbbcd12"]])

export default __exports__